<template>

    <vs-collapse2>

        <vs-collapse-item2>
            <div slot="header" >
                <div class="flex justify-between">
                    <div class="mb-6" style="color: rgb(84,93,167)">
                        {{ item.discipline.name }}
                    </div>
                    <vs-button v-if="user.role.is_office ||  user.role.is_org_admin"  @click.stop="openStudents(item)" size="small"  color="primary"  class="rounded mb-2" >
                        {{ $t("students-list") }}
                    </vs-button>
                </div>
                <div style="float:right">


                    <div class="h-full grid grid-cols-1 content-between ">

                        <div>
                            <multiselect
                                :disabled="user.role.is_supervisor && !user.role.is_office"
                                :options="GET_STATUS_COURSE"
                                v-model="item.status"
                                open-direction="bottom"
                                @select="change_status_course"
                                label="name"
                                deselectLabel=""
                                :allow-empty="false"
                                selectedLabel=""
                                selectLabel=""
                                track-by="uid">
                                <div slot="noOptions">
                                    {{$t('no_data_text')}}
                                </div>
                            </multiselect>
                        </div>
                    </div>
                </div>

                <!-- Info for discipline -->
                <h6>
                    <div class="mb-2" v-if="item.study_year.start && item.study_year.end">
                        <label class="text-primary">{{$t('study_period')}}:</label> <span> {{ `${ item.study_year.start } - ${ item.study_year.end }` }} </span>
                    </div>
                    <div class="mb-2" v-if="item.groups_control_periods.name">
                        <label class="text-primary">{{$t('semester')}}:</label> <span> {{ item.groups_control_periods.name }} </span>
                    </div>
                    <div class="mb-2" v-if="item.component && item.component.short_name">
                        <label class="text-primary">{{$t('component')}}:</label> <span> {{ item.component.short_name }} </span>
                    </div>
                    <div class="mb-2" v-if="item.credit">
                        <label class="text-primary">{{$t('credits')}}:</label> <span> {{ item.credit }} </span>
                    </div>
                    <div class="mb-2" v-if="item.discipline.courseid">
                        <label class="text-primary">{{$t('course_id')}}:</label> <span> {{ item.discipline.courseid }} </span>
                    </div>
                    <div class="mb-2" v-if="item.discipline.courseabbreviation">
                        <label class="text-primary">{{$t('course_abbreviation')}}:</label> <span> {{ item.discipline.courseabbreviation }} </span>
                    </div>
                </h6>

            </div>
            <div v-for="(element,indexr) in item.flux_online_registration" :key="indexr" >
                <vs-list-header2
                    :course_uid="item.uid"
                    :course_index="index"
                    :flux_index="indexr"
                    :element="element"
                    :lesson="element.lesson_online_registrations"
                    :title="$t('Section')+' '+element.number_of_times_per_week"/>

                <vs-list-item2
                    :course_uid="item.uid"
                    :course_index="index"
                    :flux_index="indexr"
                    :lesson_index="i"
                    :item="el"
                    v-for="(el,i) in element.lesson_online_registrations"
                    :key="i"
                    :title="el.load_type.name"/>
            </div>
        </vs-collapse-item2>

    </vs-collapse2>

</template>

<script>
import vsCollapse2 from './vsCollapse/vsCollapse'
import vsCollapseItem2 from './vsCollapse/vsCollapseItem'
import vsListHeader2 from './vsList/vsListHeader'
import vsListItem2 from './vsList/vsListItem'
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    name: "ListItem",
    props:{
        item:{},
        index:Number,
    },
    components:{
        vsCollapse2,
        vsCollapseItem2,
        vsListHeader2,
        vsListItem2,
    },
    data (){
        return{
        }
    },
    computed:{
        ...mapGetters({
            GET_STATUS_COURSE:'discipline_registration_access/GET_STATUS_COURSE'
        }),
        user() {
            return this.$store.state.user.user
        },
    },
    methods:{
        ...mapMutations({
            CHANGE_STATUS_COURSE_STATE:'discipline_registration_access/CHANGE_STATUS_COURSE_STATE',
        }),
        ...mapActions({
            CHANGE_LESSONS:'online_registration/CHANGE_LESSONS'
        }),
        async get_lessons(){
            let lessons = []
            this.item.flux_online_registration.forEach((element)=>{
                element.lesson_online_registrations.forEach((el)=>{
                    lessons.push(el.uid)
                })
            })
            return lessons
        },
        async change_status_course(value){
            await this.CHANGE_STATUS_COURSE_STATE({status:value,key:this.index})
            await this.CHANGE_LESSONS({
                data:{
                    data:await this.get_lessons(),
                    status:value?value.uid:null,
                    course_uid:this.item.uid,
                },params:{}
            })

        },
        openStudents(item){

            let query = {
                discipline : item.discipline.uid,
                groups_control_periods : item.groups_control_periods.uid,
                study_year : item.study_year.uid,
                courses_online_registration_uid:item.uid,
                ...this.$route.query
            }
            this.$router.push({name:'discipline_registration_access_for_selected_students', query:query})
        }
    }
};
</script>

<style lang="scss">
.multiselect__option--selected{
    background-color: rgba(var(--vs-primary), 1);
    color: rgb(255, 255, 255);
}
</style>
